import { Bleed, Button, H6, Separator, Subheading } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { css } from '@emotion/core'
import React, { useState } from 'react'
import { ControlView } from '@fs/zion-icon'
import Coverages from '../../../Lightyear/views/imageBrowse/groupData/coverages/Coverages'
import Metadata from '../../../Lightyear/views/imageBrowse/groupData/metadata/Metadata'

const containerCss = css`
  background-color: var(--gray02);
  padding: 16px;
`
const rootCss = css`
  padding: 16px 0;
`

const viewMetadataText = () => i18n.t('attach.viewMetaData', 'View image group metadata')
const viewMetadataSubheaderText = () =>
  i18n.t(
    'attach.viewMetadataSubheaderMessage',
    'This metadata will not be included in the source. Copy any important data into the Notes field.'
  )
const hideText = () => i18n.t('attach.hideButton', 'Hide')
const showText = () => i18n.t('attach.showButton', 'Show')

const ViewMetadata = () => {
  const [showMetadata, setShowMetadata] = useState(false)
  const toggleShowMetaData = () => {
    setShowMetadata(!showMetadata)
  }

  function viewIcon() {
    return <ControlView toggle={showMetadata} />
  }

  return (
    <div css={rootCss}>
      <H6>
        {viewMetadataText()}
        <Subheading>{viewMetadataSubheaderText()}</Subheading>
      </H6>
      <Button Icon={viewIcon} onClick={toggleShowMetaData}>
        {showMetadata ? hideText() : showText()}
      </Button>
      <Separator size="sm" />

      {showMetadata && (
        <Bleed sides>
          <div css={containerCss}>
            <Coverages />
            <Metadata copyable />
          </div>
        </Bleed>
      )}
      <Separator size="lg" />
    </div>
  )
}

export default ViewMetadata
